import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// -- Production console strip --------------------------------------------
// Diagnostic `console.warn` / `console.debug` calls live inside every
// error-handler in the codebase (auth probes, form-draft persistence,
// data-editor prefetch, etc.). They're helpful in dev but we don't want
// them spamming a coach's browser console in production. `console.error`
// is left intact so hard failures still surface to error-tracking tools.
//
// This is a runtime no-op override rather than a build-time strip —
// react-scripts doesn't expose Terser's `drop_console` without a CRACO
// / react-app-rewired shim, and the runtime cost of these no-ops is
// negligible next to a proper build-config change.
if (process.env.NODE_ENV === "production") {
  const noop = () => {};
  console.log = noop;
  console.warn = noop;
  console.debug = noop;
  console.info = noop;
}

// Silence Recharts' transient "width(-1)/height(-1)" warning.
// In React StrictMode + flex/grid layouts, ResponsiveContainer briefly
// measures its parent before layout has settled and emits this warning on
// every tab switch / chart remount. The chart renders correctly a tick
// later, so the warning is purely cosmetic — but the dev overlay flashes
// it on screen which is confusing for non-devs. Applied AFTER the prod
// override so it only runs in dev where console.warn is still live.
if (process.env.NODE_ENV !== "production") {
  const originalWarn = console.warn;
  console.warn = (...args) => {
    const first = args[0];
    if (typeof first === "string" && first.includes("width(-1) and height(-1)")) return;
    originalWarn(...args);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
